import { AddLodgingOptionState, AddLodgingOptionActionTypes, ADD_LODGING_OPTION_DATA_REQUEST, ADD_LODGING_OPTION_DATA_SUCCESS, ADD_LODGING_OPTION_DATA_FAILURE } from "store/reducers/lodgingOption/add/types";

const defaultState: AddLodgingOptionState = {
  isLoading: false,
  errorMessage: ""
};

export default function addLodgingOption(state = defaultState, action: AddLodgingOptionActionTypes): AddLodgingOptionState {
  switch (action.type) {
    case ADD_LODGING_OPTION_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ADD_LODGING_OPTION_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case ADD_LODGING_OPTION_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};